import client from "./client";

export interface TeamLeaveSlice {
  leave_type: string;
  start_date: string;
  end_date: string;
  status: string;
}

export interface TeamMember {
  id: string;
  first_name: string;
  last_name: string;
  preferred_name: string | null;
  title: string;
  avatar_url: string | null;
  work_email: string | null;
  department_name: string | null;
  hire_date: string;
  tenure_months: number;
  status: string;
  pto_balance: number | null;
  pto_used: number | null;
  pto_total: number | null;
  pending_documents: number;
  last_review_date: string | null;
  next_review_due: string | null;
  current_leave: TeamLeaveSlice | null;
  upcoming_leave: TeamLeaveSlice | null;
}

export interface TeamRoster {
  manager_id: string;
  headcount: number;
  on_leave_today: number;
  members: TeamMember[];
}

export interface TeamCalendarEntry {
  employee_id: string;
  employee_name: string;
  date: string;
  type: "leave" | "holiday";
  leave_type: string | null;
  status: string | null;
}

export interface TeamAlert {
  code:
    | "overdue_documents"
    | "reviews_due"
    | "pending_approvals"
    | "negative_pto"
    | string;
  severity: "info" | "warning" | "danger" | string;
  message: string;
  count: number;
  action_path: string | null;
}

export interface TeamAlertsResponse {
  alerts: TeamAlert[];
  total: number;
}

export async function getMyTeam(): Promise<TeamRoster> {
  const { data } = await client.get("/my/team");
  return data;
}

export async function getMyTeamCalendar(
  startDate: string,
  endDate: string,
): Promise<TeamCalendarEntry[]> {
  const { data } = await client.get("/my/team/calendar", {
    params: { start_date: startDate, end_date: endDate },
  });
  return data;
}

export async function getMyTeamAlerts(): Promise<TeamAlertsResponse> {
  const { data } = await client.get("/my/team/alerts");
  return data;
}
